<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import '@shared/assets/styles/global.scss';
import '@shared/assets/styles/font.scss';
import '@shared/assets/styles/layout.scss';
import '@shared/assets/styles/margin.scss';
import '@shared/assets/styles/image.scss';
import '@shared/assets/styles/modal.scss';
import '@shared/assets/styles/tag.scss';
import '@shared/assets/styles/button.scss';
import '@shared/assets/styles/padding.scss';

import axios from 'axios';

export default {
  name: 'App',
  beforeCreate() {
    if (!localStorage.currentUser && this.$route?.query?.token) {
      const currentUser = {
        token: this.$route.query.token,
      };
      localStorage.currentUser = JSON.stringify(currentUser);
    }
    if (localStorage.maintenanceMode) {
      axios({
        method: 'GET',
        url: `${process.env.API_URL}/test/connect/data`
      }).then(() => {
        localStorage.removeItem('maintenanceMode');
        this.$router.go();
      }).catch(err => {
        if (err.response?.status === 503) {
          localStorage.maintenanceMode = JSON.stringify(err.response.data);
          this.$router.push('/not-found');
        }
      });
    }
  },
};
</script>

<style lang="scss">
:root {
  --bg-color: #142145;
  --text-color: #FFFFFF;
  --label-color: #2B3757;
  --chart-bg: #0E1632;
}
.light-mode {
  --bg-color: #DBE4FF;
  --text-color: #000000;
  --label-color: #FFFFFF;
  --chart-bg: #FFFFFF;
}

#app {
  display: flex;
  flex: 1;

  .admin-loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }
}

#inspire {
  flex: 1;
}

.blue-text {
  color: $NBLUE90 !important;
  font-weight: 500;
  white-space: nowrap;
}

.red-text {
  color: $TOMATO100 !important;
  font-weight: 500;
  white-space: nowrap;
}

.green-text {
  color: $BASIL100 !important;
  font-weight: 500;
  white-space: nowrap;
}

.yellow-text {
  color: $SUNSET100 !important;
  font-weight: 500;
  white-space: nowrap;
}

.black-text {
  color: $BLACK !important;
  font-weight: 500;
  white-space: nowrap;
}

.ac-close-button {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: $NBLUE10;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: $NBLUE20;
  }

  .ac-close {
    width: 10px;
    height: 10px;
  }
}
</style>
